import React from 'react';
import { Card, DatePicker, Form, Input } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import Calendar from '../svg/Calendar';

const { TextArea } = Input;

interface AccommodationProps {
  form: FormInstance;
}

const Accommodation: React.FC<AccommodationProps> = ({ form }) => {
  return (
    <FormSection title="Accommodation" columns={3}>
      <Form.Item
        label="What did you request?"
        name={['accommodation_info', 'accommodation_requested']}
      >
        <Input placeholder="Describe what you requested" />
      </Form.Item>

      <Form.Item
        label="What was the date of this request?"
        name={['accommodation_info', 'date_of_request']}
      >
        <DatePicker placeholder="DD/MM/YYYY" suffixIcon={<Calendar />} format={"DD/MM/YYYY"} inputReadOnly />
      </Form.Item>
    </FormSection>
  );
};

export default Accommodation;

